import Component from '../inherited/Component';
import axios from 'axios';

export default class RecommendedProducts extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._container = this._elem.querySelector('[data-recommended-products-container]');
  }

  async mount() {
    let url = `${this._options.baseUrl}?section_id=product-recommendations&product_id=${this._options.productId}&limit=${this._options.limit}&intent=${this._options.intent}`;
    let { data } = await axios.get(url);

    let parser = new DOMParser();
    let html = parser.parseFromString(data, 'text/html');

    let items = html.querySelectorAll('[data-recommended-item]');
    let fragment = document.createDocumentFragment();

    if (items.length === 0) {
      this._elem.parentElement.remove();
    }

    for (let item of items) {
      fragment.appendChild(item);
    }

    this._theme.mountComponents(fragment);

    this._container.append(fragment);

    this._ctx.emit('radiant--lazy-load-update');
    this._ctx.emit('radiant--quicklink-listen-to', null, this._container);

    if (this._options.compToMount) {
      let compObj = this._theme.getComponent(this._options.compToMount);
      if (compObj) {
        compObj.component._options.mount = true;
        compObj.component.mount();
      }
    }
  }
}
